module.exports = __webpack_public_path__ + "images/paypal-1B3g94g.svg";